export default "__VITE_ASSET__4a97ad8c__"